import { ref, watchEffect, computed } from 'vue';
import { identityProviderInitiate } from 'identity-provider-connector';
import auth from '@/plugins/auth';
import useRequestToast from "@/composables/useRequestToast";


export function useIsEnabledIds() {
  if (process.env.VUE_APP_IDENTITY_PROVIDER_CONNECTOR_ENABLED !== '1') {
    return false;
  }
  const envVar = process.env.VUE_APP_IDENTITY_PROVIDER_CONNECTOR_ENABLED_IDS;
  const enabledIds = envVar ? envVar.split(',').map((el) => Number(el)) : [];

  return enabledIds.length ? enabledIds.includes(auth?.user()?.id) : true;

}
export default function useIdentityProvider() {
  const token = ref(auth.token());
  const isLoggedIn = ref(auth.check());

  watchEffect(() => {
    token.value = auth.token();
    isLoggedIn.value = auth.check();
  });
  const baseURL = process.env.VUE_APP_API_URL;
  const providerName = process.env.VUE_APP_IDENTITY_PROVIDER_CONNECTOR_APPLICATION_NAME;

  const apiSettingsOpt = computed(() => {
    return {
      baseURL,
      providerName,
      token: token.value,
    };
  });

  const initIdentityProvider = () => {
    if (process.env.VUE_APP_IDENTITY_PROVIDER_CONNECTOR_ENABLED === '1') {
      identityProviderInitiate({
        apiSettingsOpt,
        isLogged: isLoggedIn,
        checkIfEnabled: useIsEnabledIds
      });
    }
  };

  return {
    initIdentityProvider,
  };
}

export function handleIdentityProviderError(error, router) {
  const { openToast } = useRequestToast();
  openToast({ message: error?.message, color: 'danger' });
  router.push('/login');
}
